<template>
	<editor
		:show.sync="editorVisible"
		:title="title"
		:alert-info="alertInfo"
		:data-model-name="editorDataModel"
		:record-id="recordId"
		:fields="editorFields"
		:handler-url="handlerUrl"
		@change="doChange"
		:check-ever-edited="false"
		v-if="editorVisible"
	></editor>
</template>

<script>
export default {
	data() {
		return {
			editorDataModel: "Cashflow"
		};
	},
	computed: {
		editorFields() {
			if (this.isIncome) {
				return [
					{
						name: "show_id",
						isOnlyShow: true,
						col: 6
					},
					{
						name: "customer",
						isOnlyShow: true,
						col: 6
					},
					{
						name: "total_price",
						rules: ["required"],
						col: 6
					},
					{
						name: "pay_method",
						rules: ["required"],
						col: 6
					},

					{
						name: "payed_at",
						sortable: "custom",
						rules: ["required"],
						col: 6
					},
					{
						name: "name",
						sortable: "custom",
						rules: ["required"]
					},
					{
						name: "desc",
						sortable: "custom"
					},
					{
						name: "primary_img"
					}
				];
			} else {
				return [
					{
						name: "show_id",
						sortable: "custom",
						isOnlyShow: true,
						col: 6
					},
					{
						name: "supplier",
						sortable: "custom",
						isOnlyShow: true,
						col: 6
					},
					{
						name: "total_price",
						rules: ["required"],
						col: 6
					},
					{
						name: "pay_method",
						rules: ["required"],
						col: 6
					},

					{
						name: "payed_at",
						sortable: "custom",
						rules: ["required"],
						col: 6
					},
					{
						name: "name",
						sortable: "custom",
						rules: ["required"]
					},
					{
						name: "desc",
						sortable: "custom"
					},
					{
						name: "primary_img"
					}
				];
			}
		},
		editorVisible: {
			get: function() {
				return this.show;
			},
			set: function(val) {
				this.$emit("update:show", val);
			}
		},
		title() {
			if (this.isIncome) {
				return "确认已经收到款项, 是否继续?";
			} else {
				return "确认已经完成支付, 是否继续? ";
			}
		},
		alertInfo() {
			if (this.isIncome) {
				return "如果选择用户余额支付，将检查用户余额是否足够并直接扣费";
			} else {
				return "如果实际并未发生付款退款行为，请直接删除订单，无需退款";
			}
		},
		handlerUrl() {
			if (this.isIncome) {
				return "cashflow/do_edit_cashflow/income";
			} else {
				return "cashflow/do_edit_cashflow/outcome";
			}
		}
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		recordId: {
			type: String,
			default: ""
		},
		isIncome: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		doChange(val) {
			this.$emit("change", val);
		}
	}
};
</script>